export default __webpack_public_path__ + "static/media/grid_1__07.018e1d5d.jpg";